import {
  ANSWER_NONE_OF_THE_ABOVE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_SINGLE,
} from '../../../constants';

export function getAnswerClass({ question, column = {} } = {}) {
  let answerClass = '';

  switch (question.style) {
    case QUESTION_MATRIX_SINGLE:
      answerClass = 'single-choice';
      break;
    case QUESTION_MATRIX_MULTIPLE:
      answerClass = 'multi-choice';
      break;
    default:
      answerClass = 'single-choice';
  }

  if (column.isExclusive === true) {
    answerClass += ' exclusive-answer';
  }

  if (column.style === ANSWER_NONE_OF_THE_ABOVE) {
    answerClass += ' none-of-the-above';
  }

  return `answer--${answerClass}`;
}

export function removeScorepointFromAnswerArray(
  scorepointIdToRemove,
  answersArray,
  answerId,
) {
  const newAnswersArray = answersArray.map((answer) => {
    if (answer.answerId === answerId) {
      const newScorepointIds = answer.scorepointIds.filter(
        (scorepointId) =>
          scorepointId.toString() !== scorepointIdToRemove.toString(),
      );
      return {
        ...answer,
        scorepointIds: newScorepointIds,
      };
    }
    return answer;
  });

  const $answerElement = $(`[data-answer-id="${answerId}"]`);
  $answerElement
    .find(`[data-scorepoint-id="${scorepointIdToRemove}"]`)
    .removeClass('answer--click');

  $answerElement
    .find(`.matrix__labels [data-scorepoint-id="${scorepointIdToRemove}"]`)
    .removeClass('matrix__selected-answer--active');

  return newAnswersArray;
}
